import { createQueryKeys } from '@lukemorales/query-key-factory'
import { RequestTypes } from './requestTypes'
import { APIAxiosInstance } from '@core/utils/api-axios-instance'
import { createQueryKeyString } from '@core/react-query/queryParams'

export const analyticsKeys = createQueryKeys('analytics', {
  getAnalyticsDashboardList: (
    payload: RequestTypes['getAnalyticsDashboardList'],
  ) => {
    const url = () => {
      if (payload.projectId) {
        return `${Project.apiBaseUrl}data/dashboards/organisations/${payload.organisationId}/projects/${payload.projectId}`
      } else if (payload.businessUnitId) {
        return `${Project.apiBaseUrl}data/dashboards/organisations/${payload.organisationId}/business-units/${payload.businessUnitId}`
      }
      return `${Project.apiBaseUrl}data/dashboards/organisations/${payload.organisationId}`
    }

    return {
      queryKey: [payload.organisationId, payload.projectId],
      queryFn: async () => {
        const { data } = await APIAxiosInstance.get(url())
        return data
      },
    }
  },

  getUserCategories: () => {
    return {
      queryKey: ['user-categories'],
      queryFn: async () => {
        const { data } = await APIAxiosInstance.get(
          `${Project.apiBaseUrl}data/dashboards/user-categories`,
        )
        return data
      },
    }
  },

  generateAnalyticsDashboard: (
    payload: RequestTypes['generateAnalyticsDashboard'],
  ) => {
    return {
      queryKey: [payload.dashboardId],
      queryFn: async () => {
        const { data } = await APIAxiosInstance.post(
          `${Project.apiBaseUrl}data/dashboards/${payload.dashboardId}/generate`,
          {
            ...(payload.inputs && { inputs: payload.inputs }),
            ...(payload.graphicInputs && {
              graphicInputs: payload.graphicInputs,
            }),
            ...(payload.previous && { previous: payload.previous }),
          },
        )

        return data
      },
    }
  },

  loadAnalyticsGraphic: (payload: RequestTypes['loadAnalyticsGraphic']) => {
    return {
      queryKey: [payload.graphicId, payload.inputs],
      queryFn: async () => {
        const { data } = await APIAxiosInstance.post(
          `${Project.apiBaseUrl}data/graphics/${payload.graphicId}/load`,
          {
            inputs: payload.inputs,
          },
        )

        return data
      },
    }
  },

  downloadAnalyticsDashboard: (
    payload: RequestTypes['downloadAnalyticsDashboard'],
  ) => {
    return {
      queryKey: [payload.dashboardId],
      queryFn: async () => {
        const { data } = await APIAxiosInstance.post(
          `${Project.apiBaseUrl}data/dashboards/${payload.dashboardId}/download?mediaType=${payload.mediaType}`,
          {
            ...(payload.inputs && { inputs: payload.inputs }),
            ...(payload.graphicInputs && {
              graphicInputs: payload.graphicInputs,
            }),
            ...(payload.previous && { previous: payload.previous }),
          },
        )

        return data
      },
    }
  },

  getAnalyticsConversational: (
    payload: RequestTypes['getAnalyticsConversational'],
  ) => {
    return {
      queryKey: [payload.tracking_id, payload.org_id, payload.question],
      queryFn: async () => {
        const queryString = createQueryKeyString(payload)

        const { data } = await APIAxiosInstance.get(
          `${Project.apiBaseUrl}data/open-ai-query/graphic-response${queryString}`,
        )

        return data
      },
    }
  },
})
